import {Injectable} from "@angular/core";
import { environment } from "../../environments/environment";
import {
    TAB_KEYS, getTabValue, setTabValue, removeTabValue, clearTabSession, advanceContextVersion
} from "./tab-session";

/**
 * Application state of this tab (see tab-session.ts). Values live in sessionStorage, so another tab of the same
 * browser keeps its own organization, account and language.
 */
@Injectable()
export class WebstorageService {

    public data:any=[];

    constructor() {}

    storeData(key, val): void {
        setTabValue(key, val);
        this.data[key]= getTabValue(key);
    }

    getData(key): string {
        this.data[key]= getTabValue(key);
        return this.data[key];
    }

    removeData(key): void {
        removeTabValue(key);
    }

    /** Ends this tab's application session only; other tabs and the identity provider's own storage are untouched. */
    removeAllData(): void {
        clearTabSession();
        this.data = [];
        this.applyPartner(null);
        environment._TenantID = null;
    }

    /** Selects the organization this tab works in. Requests started for the previous organization are dropped. */
    setPartner(partnerId: string): void {
        setTabValue(TAB_KEYS.partnerId, partnerId);
        this.applyPartner(partnerId || null);
    }

    clearPartner(): void {
        removeTabValue(TAB_KEYS.partnerId);
        removeTabValue(TAB_KEYS.tenantId);
        removeTabValue(TAB_KEYS.multilingual);
        this.applyPartner(null);
        environment._TenantID = null;
    }

    private applyPartner(partnerId: string | null): void {
        if (environment._PartnerID !== partnerId) {
            advanceContextVersion();
        }
        environment._PartnerID = partnerId;
    }
}
